import './RowRateFilter.scss'

export default function RowRateFilter(props: any) {
  const title = props?.title
  const icon = props?.icon
  const defaultValue = props?.defaultValue

  const handleChangeFilter = (tab: string) => {
    if (tab === defaultValue) {
      props?.filterAction('')
    } else {
      props?.filterAction(tab)
    }
  }

  return (
    <>
      <div className='knqgonypir'>
        <div className='duqcjaterr'>
          <span className='gkeijevcoz'>{icon}</span>
          <span>{title}</span>
        </div>
        <div className='oboklynemq'>
          <div onClick={() => handleChangeFilter('A')} className={`acjrizekzs ${defaultValue == 'A' ? 'xNjpjfSQAj' : ''}`}>A</div>
          <div onClick={() => handleChangeFilter('B')} className={`acjrizekzs ${defaultValue == 'B' ? 'xNjpjfSQAj' : ''}`}>B</div>
          <div onClick={() => handleChangeFilter('C')} className={`acjrizekzs ${defaultValue == 'C' ? 'xNjpjfSQAj' : ''}`}>C</div>
          <div onClick={() => handleChangeFilter('D')} className={`acjrizekzs ${defaultValue == 'D' ? 'xNjpjfSQAj' : ''}`}>D</div>
        </div>
      </div>
    </>
  )
}